import React, { useEffect } from 'react'
import { Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import strings from "../../utils/property-file/setting.json"

function SettingsConfirmationModal({isSettingsEdited,handleCancel,handleConfirm}) {

  useEffect(() => {
  if (isSettingsEdited) {
    const modalContent = document.querySelector(".skip-checkout-dialog .modal-content");
    if (modalContent) {
      modalContent.classList.add("modal-content-checkout");
    }
  }
}, [isSettingsEdited]);

  return (
   <Modal show={isSettingsEdited} onHide={handleCancel} size="sm" centered dialogClassName="skip-checkout-dialog">
      <Modal.Header>
            <p className="heading-text">
              {strings.settingsConfirmationHeading}
            </p>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center flex-column align-items-center ">
          <div>{strings.settingsConfirmationMsg}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          {strings.cancelbtn}
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          {strings.okbtn}
        </Button>
      </Modal.Footer>

    </Modal>
  )
}

SettingsConfirmationModal.propTypes = {
  isSettingsEdited: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
};

export default SettingsConfirmationModal